import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';
import { Master } from '../../model';

export default class UpStair {
    wallView: SVGElement;

    dummyWallView: SVGElement;

    x: number;

    y: number;

    rotation: number;

    private dragInitX: number;

    private dragInitY: number;

    public spt: SVGSprite;

    public patternSpt: SVGSprite;

    public parentLayer: marietta.webcad.layer.UpStairsLayer;

    partnerStair: marietta.webcad.item.Stair;

    // 表示非表示
    _visible: boolean;

    set visible(booValue: boolean) {
      this._visible = booValue;
    }

    get visible() { return this._visible; }

    // パートナーの情報取得
    get itemInfo() {
      return this.partnerStair.itemInfo;
    }

    /**
     * コンストラクタ
     */
    constructor(_partnerStair: marietta.webcad.item.Stair) {
      this.partnerStair = _partnerStair;

      // レイヤー
      if (this.partnerStair.itemInfo.floor > 2) return;
      this.parentLayer = marietta.webcad.WebCADGlobal.layerGroup.getTargetLayer('ust', this.partnerStair.itemInfo.floor + 1) as marietta.webcad.layer.UpStairsLayer;

      const group: Element = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      group.setAttribute('id', `${this.itemInfo.id}_up${this.itemInfo.guid}`);
      this.spt = new SVGSprite(group);

      const pattern: SVGElement = Master.getItemSvg(`${this.itemInfo.id}_up`);
      this.patternSpt = new SVGSprite(pattern);
      this.patternSpt.width = this.itemInfo.width;
      this.patternSpt.height = this.itemInfo.height;
      this.patternSpt.update();
      this.spt.addChild(this.patternSpt);

      // 壁
      this.wallView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.wallView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}wallGroup`);
      let wall: marietta.webcad.item.parts.Wall;
      for (let i: number = 0; i < this.itemInfo.dotList.length; i += 1) {
        // 生成
        wall = new marietta.webcad.item.parts.Wall(i, this.wallView, this.itemInfo.dotList[i], (i === this.itemInfo.dotList.length - 1) ? this.itemInfo.dotList[0] : this.itemInfo.dotList[i + 1]);
        wall.viewObj.setAttribute('stroke-linecap', 'square');
        wall.wallType = this.itemInfo.dotList[i].wall_type;
        wall.parentObj = this.partnerStair;
      }
      this.viewObj.appendChild(this.wallView);

      // 穴を埋めるダミー壁
      if (this.dummyWallView) this.dummyWallView.remove();
      this.dummyWallView = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      this.dummyWallView.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}wallGroupDummy`);
      let dummyWallObj: SVGElement;
      let maeDot: marietta.webcad.collection.PointCollection;
      let atoDot: marietta.webcad.collection.PointCollection;
      let nextPoint: marietta.core.Point;
      let dot1: marietta.core.Point;
      let dot2: marietta.core.Point;
      let scale: number;
      let points: marietta.core.Point[] = [];
      let wallColor;

      for (let i = 0; i < this.itemInfo.dotList.length; i += 1) {
        points = [];
        // 前後の壁
        maeDot = (i === 0) ? this.itemInfo.dotList[this.itemInfo.dotList.length - 1] : this.itemInfo.dotList[i - 1];
        atoDot = (i === this.itemInfo.dotList.length - 1) ? this.itemInfo.dotList[0] : this.itemInfo.dotList[i + 1];
        wallColor = marietta.webcad.WebCADGlobal.getColorForWallType(this.itemInfo.dotList[0].wall_type);

        // どちらかも壁じゃないときは次
        if (this.itemInfo.dotList[i].wall_type >= 1) {
          // 前の壁
          dot1 = new marietta.core.Point(maeDot.x, maeDot.y);
          dot2 = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
          scale = ((marietta.core.Point.distance(dot1, dot2) - 5) / marietta.core.Point.distance(dot1, dot2));

          if (Math.abs(scale) === Infinity) {
            nextPoint = marietta.core.Point.interpolate(dot1, dot2, 1);
          } else {
            nextPoint = marietta.core.Point.interpolate(dot1, dot2, scale);
          }

          points.push(new marietta.core.Point(nextPoint.x, nextPoint.y));
          points.push(new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y));

          dot1 = new marietta.core.Point(this.itemInfo.dotList[i].x, this.itemInfo.dotList[i].y);
          dot2 = new marietta.core.Point(atoDot.x, atoDot.y);
          scale = (5 / marietta.core.Point.distance(dot1, dot2));
          if (Math.abs(scale) === Infinity) {
            nextPoint = dot2;
          } else {
            nextPoint = marietta.core.Point.interpolate(dot1, dot2, scale);
          }

          points.push(new marietta.core.Point(nextPoint.x, nextPoint.y));

          dummyWallObj = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          dummyWallObj.setAttribute('d', marietta.webcad.util.SVGUtil.getPathString(points));
          dummyWallObj.setAttribute('stroke', wallColor.color);
          dummyWallObj.setAttribute('opacity', wallColor.alpha);
          dummyWallObj.setAttribute('stroke-width', String(marietta.webcad.WebCADGlobal.WALL_WIDTH));
          dummyWallObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.index}wallGroupDummy_${i}`);
          this.dummyWallView.appendChild(dummyWallObj);
        }
      }
      this.viewObj.appendChild(this.dummyWallView);

      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      this.spt.update();
      this.spt.mouseEnabled = false;
      this.parentLayer.addParts(this);

      this.syncToPartner();
    }

    /**
     * Translateのアップデート
     */
    syncToPartner() {
      if (!this.spt) return; // 上階階段が生成できなかった場合
      this.spt.element.setAttribute('transform', this.partnerStair.viewObj.getAttribute('transform'));

      const result = this.spt.element.querySelectorAll('g');

      // 文字を反転させる
      for (let i: number = 0; i < result.length; i += 1) {
        if ((result[i] as Element).getAttribute('name') === 'moji') {
          (result[i] as Element).setAttribute('transform', marietta.webcad.WebCADGlobal.getTransformMatrixForReverseUpStairs(this.partnerStair));
        }
      }
    }

    /**
     * 表示ON
     */
    show() {
      if (!this.spt) return; // 上階階段が生成できなかった場合

      this.spt.element.style.visibility = 'visible';
      // 表示の再設定
      this.visible = this._visible;
    }

    /**
     * 表示ON
     */
    hide() {
      if (!this.spt) return; // 上階階段が生成できなかった場合

      this.spt.element.style.visibility = 'hidden';
    }

    /**
     * 削除
     */
    deleteMe() {
      if (!this.spt) return; // 上階階段が生成できなかった場合

      this.spt.remove();
      this.parentLayer.deleteItem(this);
    }

    public get viewObj(): HTMLElement {
      if (!this.spt) return null; // 上階階段が生成できなかった場合

      return this.spt.element;
    }

    /**
     * 移動 XY
     */
    move(x: number, y: number) {
      this.itemInfo.x = x;
      this.itemInfo.y = y;
      this.updateTransforms();
    }

    /**
     * Translateのアップデート
     */
    updateTransforms() {
      this.spt.x = this.itemInfo.x;
      this.spt.y = this.itemInfo.y;
      if (Number.isNaN(this.spt.scaleX)) this.spt.scaleX = 1;
      if (Number.isNaN(this.spt.scaleY)) this.spt.scaleY = 1;
      this.spt.rotation = this.itemInfo.rotation;
      this.spt.update();
    }
}
